module.exports = __webpack_public_path__ + "img/工业制造.ed568568.png";